import axios from "axios";
import Cookies from "js-cookie";
const source = axios.CancelToken.source();
const token = Cookies.get("token");
let instance;
instance = axios.create({
  //  baseURL: "http://192.168.1.104:4546",
 baseURL: "https://admin.viot.mn:4545",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  cancelToken: source.token,
});
instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

export default instance;
